/**
 * handler 공용 도구. 에러 본문은 FastAPI 형태(`{ detail }`)로 맞춘다 —
 * apiClient 의 detailMessage 가 실제 백엔드와 같은 경로로 문구를 꺼내게.
 */
import { HttpResponse, delay } from "msw";
import type { Me } from "@/types";
import { db } from "./db";

/** 실제 네트워크처럼 응답을 늦춘다(100~400ms). 로딩 상태가 화면에 보이게. */
export const latency = () => delay();

export const fail = (status: number, detail: string) => HttpResponse.json({ detail }, { status });

/** 세션 사용자를 꺼내고, 없으면 401 응답을 돌려준다. */
export function requireUser(): Me | Response {
  return db.currentUser() ?? fail(401, "로그인이 필요합니다.");
}

/** 관리자와 HR 표시가 있는 사람만 통과 — 근태와 직원 관리. */
export function requireHr(): Me | Response {
  const user = requireUser();
  if (user instanceof Response) return user;
  return user.role === "admin" || user.is_hr ? user : fail(403, "이 기능을 쓸 권한이 없습니다.");
}

/** 관리자만 통과. 세션이 없으면 401, 역할이 아니면 403. */
export function requireAdmin(): Me | Response {
  const user = requireUser();
  if (user instanceof Response) return user;
  return user.role === "admin" ? user : fail(403, "관리자만 바꿀 수 있습니다.");
}
